// This file contains fully detailed dummy data for active session locations within Los Angeles County.
export const dummyActiveLocations = [
    // Downtown LA & Eastside
    {
        id: 1, lat: 34.0522, lng: -118.2437,
        name: "Downtown LA Skills Clinic",
        sport: "Basketball",
        address: "123 Figueroa St, Los Angeles, CA",
        eventDate: "2025-09-15T17:00:00Z",
        eventTimeRange: "5:00 PM - 7:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1546519638-68e109498ffc?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 18,
        capacity: 25,
        coachNames: ["John Doe"],
        siteManagerNames: ["Jane Smith"],
        sessionRevenue: { totalRevenue: 540 },
        projectedProfit: 250,
    },
    {
        id: 2, lat: 34.0488, lng: -118.2518,
        name: "Financial District Rooftop Yoga",
        sport: "Yoga",
        address: "456 Grand Ave, Los Angeles, CA",
        eventDate: "2025-09-16T08:00:00Z",
        eventTimeRange: "8:00 AM - 9:00 AM",
        venueImage1: "https://images.unsplash.com/photo-1599447462856-614d48a01sin?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Active",
        reservations: 20,
        capacity: 20,
        coachNames: ["Emily White"],
        siteManagerNames: ["Carlos Rey"],
        sessionRevenue: { totalRevenue: 600 },
        projectedProfit: 350,
    },
    {
        id: 3, lat: 34.0722, lng: -118.2950,
        name: "Echo Park Run Club",
        sport: "Running",
        address: "751 Echo Park Ave, Los Angeles, CA",
        eventDate: "2025-09-17T18:00:00Z",
        eventTimeRange: "6:00 PM - 7:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 30,
        capacity: 50,
        coachNames: ["David Lee"],
        siteManagerNames: ["Maria Garcia"],
        sessionRevenue: { totalRevenue: 300 },
        projectedProfit: 150,
    },
    {
        id: 4, lat: 34.0837, lng: -118.2949,
        name: "Silver Lake Tennis Match",
        sport: "Tennis",
        address: "2290 Silver Lake Blvd, Los Angeles, CA",
        eventDate: "2025-09-18T10:00:00Z",
        eventTimeRange: "10:00 AM - 12:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1559529738-4c4f5a3a7b77?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 4,
        capacity: 4,
        coachNames: ["Serena Williams Jr."],
        siteManagerNames: ["James Brown"],
        sessionRevenue: { totalRevenue: 200 },
        projectedProfit: 80,
    },

    // Hollywood & Mid-Wilshire
    {
        id: 5, lat: 34.0928, lng: -118.3287,
        name: "Hollywood Boxing Bootcamp",
        sport: "Boxing",
        address: "6775 Hollywood Blvd, Hollywood, CA",
        eventDate: "2025-09-19T19:00:00Z",
        eventTimeRange: "7:00 PM - 8:30 PM",
        venueImage1: "https://images.unsplash.com/photo-1594882645126-14020914d58d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Active",
        reservations: 15,
        capacity: 15,
        coachNames: ["Mike Tyson Jr."],
        siteManagerNames: ["Sandra Oh"],
        sessionRevenue: { totalRevenue: 600 },
        projectedProfit: 220,
    },
    {
        id: 6, lat: 34.0620, lng: -118.3576,
        name: "Miracle Mile Fitness",
        sport: "HIIT",
        address: "5801 Wilshire Blvd, Los Angeles, CA",
        eventDate: "2025-09-20T12:00:00Z",
        eventTimeRange: "12:00 PM - 1:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 22,
        capacity: 30,
        coachNames: ["Chris Evans"],
        siteManagerNames: ["Linda Hamilton"],
        sessionRevenue: { totalRevenue: 660 },
        projectedProfit: 400,
    },

    // Westside
    {
        id: 8, lat: 34.0242, lng: -118.4965,
        name: "Santa Monica Beach Volleyball",
        sport: "Volleyball",
        address: "Ocean Ave, Santa Monica, CA",
        eventDate: "2025-09-21T10:00:00Z",
        eventTimeRange: "10:00 AM - 12:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Active",
        reservations: 12,
        capacity: 12,
        coachNames: ["Mike Miller", "Sarah Chen"],
        siteManagerNames: ["Alex Johnson"],
        sessionRevenue: { totalRevenue: 480 },
        projectedProfit: 180,
    },
    {
        id: 11, lat: 34.0505, lng: -118.4452,
        name: "Westwood Soccer Drills",
        sport: "Soccer",
        address: "1083 Gayley Ave, Los Angeles, CA",
        eventDate: "2025-09-22T16:00:00Z",
        eventTimeRange: "4:00 PM - 6:00 PM",
        venueImage1: "https://images.unsplash.com/photo-1551958214-2d5e204a2c5a?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 25,
        capacity: 40,
        coachNames: ["Leo Messi"],
        siteManagerNames: ["Cristiano Ronaldo"],
        sessionRevenue: { totalRevenue: 750 },
        projectedProfit: 450,
    },

    // The Valley
    {
        id: 14, lat: 34.1581, lng: -118.4411,
        name: "Sherman Oaks Strength Training",
        sport: "Weightlifting",
        address: "14006 Riverside Dr, Sherman Oaks, CA",
        eventDate: "2025-09-23T09:00:00Z",
        eventTimeRange: "9:00 AM - 10:30 AM",
        venueImage1: "https://images.unsplash.com/photo-1581009137042-c55216867525?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Almost Full",
        reservations: 9,
        capacity: 10,
        coachNames: ["Arnold S."],
        siteManagerNames: ["Lou Ferrigno"],
        sessionRevenue: { totalRevenue: 450 },
        projectedProfit: 200,
    },

    // South Bay
    {
        id: 18, lat: 33.8848, lng: -118.4036,
        name: "Manhattan Beach Surf Lessons",
        sport: "Surfing",
        address: "Manhattan Beach Pier, Manhattan Beach, CA",
        eventDate: "2025-09-24T07:00:00Z",
        eventTimeRange: "7:00 AM - 9:00 AM",
        venueImage1: "https://images.unsplash.com/photo-152042912664-428271a23877?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1200",
        currentStatus: "Confirmed",
        reservations: 5,
        capacity: 8,
        coachNames: ["Kelly Slater"],
        siteManagerNames: ["Laird Hamilton"],
        sessionRevenue: { totalRevenue: 500 },
        projectedProfit: 250,
    },
];